document.addEventListener("DOMContentLoaded", async () => {
  setTimeout(updateCartAttributes, 2800);
  document.addEventListener("click", async (event) => {
    const button = event.target.closest("button");

    if (!button) return;
  
    if (button.matches(".amtCartDrawer__item__quantityInput button[name='plus'], .amtCartDrawer__item__quantityInput button[name='minus']")) {
      setTimeout(updateCartAttributes, 2500);
    }
  });
});
async function updateCartAttributes() {
  const cartItems = document.querySelectorAll(".amtCartDrawer__item");
  if (cartItems.length > 0) {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      cartItems.forEach((cartItem) => {
        const titleLink = cartItem.querySelector(
          ".amtCartDrawer__item__title a"
        );
        if (!titleLink) return;

        const url = new URL(titleLink.href, window.location.origin);
        const variantId = url.searchParams.get("variant");

        if (variantId) {
          const item = cart.items.find((i) => i.variant_id == variantId);
          if (item) {
            cartItem.setAttribute("bss-b2b-cart-item-key", item.key);
          }
          const originalPrice = cartItem.querySelector(
            ".amtCartDrawer__item__originalPrice"
          );
          const linePrice = cartItem.querySelector(
            ".amtCartDrawer__item__price__discount"
          );
          if (originalPrice)
            originalPrice.setAttribute("bss-b2b-item-original-price", "");
          if (linePrice) linePrice.setAttribute("bss-b2b-final-line-price", "");
        }
      });

      const totalPrice = document.querySelector(
        ".amtCartDrawer__footer__estTotal b"
      );
      if (totalPrice) totalPrice.setAttribute("bss-b2b-cart-total-price", "");
      
      BSS_B2B.storage.cartStorage.getAllItem();
      BSS_B2B.observer.cartSubject.notifyObserver("CartMutate", "CartPriceMutate");
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  }
}

document.addEventListener("addToCart", ()=>{
  setTimeout(()=>{
    updateCartAttributes()
  },2000)
})

document.addEventListener("click", (e)=>{
  const bssCheckout = document.querySelector(".btn.btn-checkout");
  if (typeof BSS_B2B !== "undefined" && bssCheckout && e.target.matches(".amtCartDrawer__footer__btnCheckout")) {
    e.preventDefault();
    e.stopImmediatePropagation();
    bssCheckout.click();
  }
},true)

